<template>
<div class="chapter">
<div class="inner_page">
<p class="p1">Cover Design: <a href="http://www.written-ink.com" target="_blank"><span class="t5">Written Ink Designs</span></a> | written-ink.com</p>
<p class="p1">Image(s) used under a Standard Royalty-Free License.</p>
<p class="p1">All rights reserved.</p>
<p class="p2">WARNING: This book is not transferable. It is for your own personal use. If it is sold, shared, or given away, it is an infringement of the copyright of this work.</p>
<p class="p2">No portion of this book may be transmitted or reproduced in any form, or by any means, without permission from the publisher, with the exception of brief excerpts used for the purposes of review.</p>
<p class="p2">This book is for ADULT AUDIENCES ONLY. It may contain sexually explicit scenes and graphic language which might be considered offensive by some readers.</p>
<p class="p2">This is a work of fiction. Names, characters, places, and incidents are solely the product of the author’s imagination and/or are used fictitiously, though reference may be made to actual historical events or existing locations. Any resemblance to actual persons, living or dead, is entirely coincidental.</p>
<p class="p2">Published in the United States of America.</p>
<p class="p3">* * * *</p>
<p class="p2">Thank you, DRS, for sticking by me through thick and thin. You helped to inspire and keep me going even when I was frustrated and on the verge of giving up. I appreciate every word of encouragement from you. I love you!</p>
<p class="p2">Thank you to the readers for continuing to support me on my writing journey. It has been a long one, and there were some difficult times, but your loyalty lifted me up in my times of need. As you can probably guess from the title of this book, the storyline for Forget Me Not is inspired by the flowers. I happened upon them a few months ago, but it wasn’t until recently that the idea for the storyline finally came to me. I hope you enjoy this book as much as I’ve enjoyed writing it.</p>
<p class="p3">* * * *</p>
<p class="p0"><span class="t2"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?7cca5206